import useAlchemystStoreForAi from '@/hooks/ai/client/useAlchemystStoreForAi';
import { ContextNode } from '@/types/context/context-page';
import { fetchWithRewrites } from '@/utils/fetchWithRewrites';
import { Box, Button } from '@mui/material';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { useEffect, useState } from 'react';

function ListTraces() {
  const setStoreState = useAlchemystStoreForAi((store) => store.setStoreState);
  const [traces, setTraces] = useState<
    { contexts: ContextNode[]; [key: string]: any }[]
  >([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch traces data here
    const fetchTraces = async (): Promise<void> => {
      try {
        const response = await fetchWithRewrites('/api/v1/context/traces'); // adjust endpoint as needed
        const data = await response.json();
        setTraces(data.traces);
      } catch (error) {
        console.error('Error fetching traces:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTraces().catch((err) =>
      window.alert(
        'An error occured while fetching the traces. Error: ' +
          (err as Error).message
      )
    );
  }, []);

  const columns: GridColDef[] = [
    {
      field: 'query',
      headerName: 'Query',
      flex: 1,
    },
    {
      field: 'contexts',
      headerName: 'Contexts',
      flex: 1,
      renderCell: (params) =>
        `${(params.row.contexts ?? []).length || 0} contexts`,
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      flex: 1,
      valueGetter: (params: any) => new Date(params.value).toLocaleString(),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => setStoreState({
            traceVisualizer: {
              isOpen: true,
              traceId: params.row._id,
            }
          })}
        >
          Open
        </Button>
      ),
    },
  ];

  return (
    <Box sx={{ width: '100%', height: 400 }}>
      <DataGridPro
        rows={traces}
        columns={columns}
        loading={loading}
        getRowId={(row) => row._id}
        pagination
        autoHeight
      />
    </Box>
  );
}

export default ListTraces;
